import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4cc2e6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select" }
const _hoisted_2 = { class: "select-input" }
const _hoisted_3 = { class: "label-select" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "text" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = ["src"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-more" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "Text" }, "+")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "check-box check-box-active" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-check" })
], -1))
const _hoisted_12 = { class: "text" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        for: "Input",
        class: "select-input-relative",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeSelect = !_ctx.activeSelect))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["input", _ctx.activeSelect ? 'input-active' : ''])
        }, null, 2),
        _createElementVNode("i", {
          style: _normalizeStyle(!_ctx.activeSelect ? '' : 'transform: rotateZ(180deg)'),
          class: "icon bx bx-chevron-down"
        }, null, 4)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.codes[0]) + " ", 1),
            _createElementVNode("img", {
              src: require(`../assets/${_ctx.codes[0]}.png`)
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.codes[1]) + " ", 1),
            _createElementVNode("img", {
              src: require(`../assets/${_ctx.codes[1]}.png`)
            }, null, 8, _hoisted_9)
          ])
        ]),
        _hoisted_10
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["select-data", _ctx.activeSelect ? 'select-data-active' : ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "select-items select-active"
        }, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode(_toDisplayString(item) + " ", 1),
            _createElementVNode("img", {
              src: require(`../assets/${item}.png`)
            }, null, 8, _hoisted_13)
          ])
        ]))
      }), 128))
    ], 2)
  ]))
}